// extracted by mini-css-extract-plugin
export default {"container":"LerninhaltControls_container__5VxrQ","button":"LerninhaltControls_button__fu-VT"};